// extracted by mini-css-extract-plugin
module.exports = {"results":"Results_results__1-GjU","p":"Results_p__1qi2Z","meanings-section":"Results_meanings-section__1uO7m"};